module.exports = __webpack_public_path__ + "static/media/right_double_arrow_circle.3d27b370.svg";